module.exports = __webpack_public_path__ + "static/img/lifestyle_24.05b22205.jpg";